module.exports = __webpack_public_path__ + "img/check.83ce0309.svg";